module.exports = __webpack_public_path__ + "img/logo33.c8e8636b.png";